import React from "react";
import { useSelectFlagData } from "../../../../redux/features/flagDetails/flagDetailsSlice";
import { useQuery } from "@tanstack/react-query";
import { useParams } from "react-router-dom";
import { Box, Table, Text } from "@mantine/core";
import { useTranslation } from "react-i18next";
import dayjs from "dayjs";
import { dateWithHourFormat } from "../../../../utils/dateFormat";
import { flagStatuses } from "../../../../utils/vars";
import { TableNoResults } from "../../../../components/TableNoResults/TableNoResults";
import ReviewStatusHistorySkeleton from "../../../../components/Skeletons/FlagDetailsSkeletons/ReviewStatusHistorySkeleton";

const ReviewStatusHistoryTable = () => {
  const { id } = useParams();
  const { t } = useTranslation();
  const flagData = useSelectFlagData();
  const reviewStatusHistory = flagData?.reviewStatusHistory || [];

  const rows = reviewStatusHistory?.slice(0, 3)?.map((stat) => (
    <Table.Tr key={stat.id}>
      <Table.Td w={150}>
        {dayjs(stat.datetime).format(dateWithHourFormat)}
      </Table.Td>
      <Table.Td w={160}>{flagStatuses[stat.status]}</Table.Td>
      <Table.Td w={160}>{stat?.user?.name}</Table.Td>
      <Table.Td>{stat.description}</Table.Td>
    </Table.Tr>
  ));

  const { isLoading } = useQuery({
    queryKey: ["flag-details", id],
    enabled: false, // only reads from store
  });

  if (isLoading) {
    return <ReviewStatusHistorySkeleton />
  }

  return (
    <Box>
      <Text fw={700} p="md">
        {t("flagDetails.statusReviewHistory.reviewStatusHistory")}
      </Text>
      <Table withTableBorder withColumnBorders>
        <Table.Thead>
          <Table.Tr>
            <Table.Th>{t("flagDetails.date")}</Table.Th>
            <Table.Th>
              {t("flagDetails.statusReviewHistory.reviewStatus")}
            </Table.Th>
            <Table.Th>{t("flagDetails.statusReviewHistory.employee")}</Table.Th>
            <Table.Th>
              {t("flagDetails.statusReviewHistory.description")}
            </Table.Th>
          </Table.Tr>
        </Table.Thead>
        <Table.Tbody>
          
          {rows.length > 0 ? rows : <TableNoResults colSpan={4} />}
        </Table.Tbody>
      </Table>
    </Box>
  );
};

export default ReviewStatusHistoryTable;
